import types from '../actions/form.actions';

const reducer = (state = initialEntries, action) => {

    switch (action.type) {

        case types.GET_DATA:
        case types.GET_MATRIZ_CONTROL:
        case types.GET_DATA_BY_NUMERO_CASO:
        case types.GET_DATA_BY_NUMERO_EVENTO:
        case types.GET_DATA_BY_ID:
        case types.LOAD_DATA:
            return {
                ...state,
                data: null,
                formData: null,
                successMessage: '',
                errorMessage: '',
                status: 'LOADING'
            }

        case types.STORE_DATA:
            return {
                ...state,
                formId: action.payload.formId,
                data: (action.payload.response[0] != null) ? action.payload.response : [],
                errorMessage: (action.payload.response[0] != null) ? "" : (action.payload.formId === 'MatrizControl') ? "No existe caso" : "",
                status: 'LOADED'
            }

        case types.STORE_FORM_DATA:
            return {
                ...state,
                formId: action.payload.formId,
                formData: action.payload.data.result,
                errorMessage: (action.payload.data.result == null) ? (action.payload.data.errors.length > 0) ? action.payload.data.errors[0] : "" : "",
                status: 'LOADED'
            }

        case types.SAVE_DATA:
            return {
                ...state,
                successMessage: '',
                errorMessage: '',
                status: 'LOADING'
            }

        case types.CHANGE_STATUS_FORM:
            return {
                ...state,
                formId: action.payload.formId,
                successMessage: (action.payload.data.errors.length == 0) ? (action.payload.action == 'SAVE') ? 'El registro ha sido guardado' : 'El registro ha sido eliminado' : '',
                errorMessage: (action.payload.data.errors.length != 0) ? (action.payload.action == 'SAVE') ? (action.payload.formId === 'Usuarios' || action.payload.formId === 'Evento' || action.payload.formId === 'Indicio') ? action.payload.data.errors[0] : 'Ha ocurrido un error al guardar el registro' : (action.payload.formId === 'Evento' || action.payload.formId === 'Referencias') ? action.payload.data.errors[0] : 'Ha ocurrido un error al eliminar el registro' : '',
                formData: (action.payload.data.errors.length == 0) ? (action.payload.action == 'SAVE') ? action.payload.data.result : null : null,
                status: (action.payload.data.errors.length == 0) ? 'RELOAD' : 'LOADED'
            }

        case types.CHANGE_STATUS_FORM_CATALOGO:
            return {
                ...state,
                formId: action.payload.formId,
                successMessage: action.payload.message,
                formData: null,
                status: 'RELOAD'
            }

        case types.CLEAR_MESSAGES:
            return {
                ...state,
                successMessage: '',
                errorMessage: ''
            }

        case types.CLEAR_FORM_DATA:
            return {
                ...state,
                formData: null,
                data: []
            }

        default:
            return state;
    }
};

export default reducer;

var initialEntries = {
    formId: '',
    data: null,
    formData: null,
    successMessage: '',
    errorMessage: '',
    status: ''
};